import API_ from "@/utils/axiosApi/audioApi.js"; //api育儿音频事件
import API_KAQI from "@/utils/axiosApi/cageChildApi.js"; //apil 凯奇育儿
import API_Search from "@/utils/axiosApi/searchApi.js" //api 搜索结果
export default {
  // 音频列表api
  listAPI: {
    collect: API_.cllect,
    audio: API_.getListData,
    cagechild: API_KAQI.getkqAudioList,
    doctorHome:API_KAQI.getkqDoctorAudioDetail,
    search:API_Search.getCommonSearch,
    newAudio:API_KAQI.getNewAudio
  },
  // 详情接口
  eventAPI: {
    cagechild: API_KAQI.getAudioDetail,
    doctorHome:API_KAQI.getAudioDetail,
    audio: API_.getAudioDetail,
    collect: API_.getAudioDetail,
    search:API_.getAudioDetail,
    newAudio:API_KAQI.getAudioDetail
  },
  // 收藏
  collectAPI: {
    cagechild: API_KAQI.addCollect,
    doctorHome:API_KAQI.addCollect,
    audio: API_.getCllect,
    collect: API_.getCllect,
    search:API_.getCllect,
    newAudio:API_KAQI.addCollect
  },
   // 取消收藏
   canclecollectAPI: {
    cagechild: API_KAQI.cancelCollect,
    doctorHome: API_KAQI.cancelCollect,
    audio: API_.cancelCllect,
    collect:API_.cancelCllect,
    search:API_.cancelCllect,
    newAudio:API_KAQI.cancelCollect
  },
  // 点赞
  LikeAPI: {
    doctorHome:API_KAQI.addLike,
    cagechild: API_KAQI.addLike,
    audio: API_.getLike,
    collect:API_.getLike,
    search:API_.getLike,
    newAudio:API_KAQI.addLike
  },
//取消点赞
cancleLikeAPI:{
    doctorHome:API_KAQI.cancleLike,
    cagechild:API_KAQI.cancleLike,
    audio:API_.cancelLike,
    collect:API_.cancelLike,
    search:API_.cancelLike,
    newAudio:API_KAQI.cancleLike
},

  // 增加播放量
  addPlayAPI: {
    cagechild: API_KAQI.addPlayNum,
    doctorHome:API_KAQI.addPlayNum,
    audio: API_.addPlay,
    collect: API_.addPlay,
    search: API_.addPlay,

  },
  getParams(name) {
     return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;



  },
};
